import React, { useEffect, useState } from 'react';
import alertIcon from '../Icones/icone-alerta.png';
import '../Estilos/Fontes.css';

export default function IconeMenu({
  id,
  entity,
  menuOptions,
  onEditClick,
  onMenuToggle,
  onMenuItemSelect,
  role,
  type,
}) {
  const [visivel, setVisivel] = useState(false);
  const [menuStateOptions, setMenuStateOptions] = useState([]);

  useEffect(() => {
    const menuOptionsCopy = [...menuOptions];

    // Remove 'Inativar' option if entity is disabled
    if (entity && entity.disabled && menuOptionsCopy.includes('Inativar')) {
      menuOptionsCopy.splice(menuOptionsCopy.indexOf('Inativar'), 1);
    }

    // Remove 'Ativar' option if entity is not disabled
    if (entity && !entity.disabled && menuOptionsCopy.includes('Ativar')) {
      menuOptionsCopy.splice(menuOptionsCopy.indexOf('Ativar'), 1);
    }

    // Remove 'Inativar' option if entity is OWNER
    if (entity && entity.role && entity.role === 'OWNER' && menuOptionsCopy.includes('Inativar')) {
      menuOptionsCopy.splice(menuOptionsCopy.indexOf('Inativar'), 1);
    }

    setMenuStateOptions(menuOptionsCopy);
  }, [entity, menuOptions]);

  const toggleMenuVisibility = () => {
    const newVisibility = !visivel;
    setVisivel(newVisibility);
    onMenuToggle(id, newVisibility);
  };

  const handleMenuItemClick = (menuItem) => {
    onMenuItemSelect(id, menuItem);
    setVisivel(false);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
        }}
      >
        {role === 'OWNER' && type !== 'alerts' && (
          <img
            src={require('../Icones/caneta.svg').default}
            alt="editar"
            height={46}
            width={46}
            style={{ cursor: 'pointer' }}
            onClick={() => onEditClick(id)}
          />
        )}
        {type === 'alerts' && (role === 'OWNER' || role === 'ON_DUTY') && (
          <img
            src={alertIcon}
            alt="alert-nature"
            height={46}
            width={46}
            style={{ cursor: 'pointer' }}
            onClick={onEditClick}
          />
        )}
        <img
          src={require('../Icones/menuPontos.svg').default}
          alt="menu"
          height={46}
          width={46}
          style={{ cursor: 'pointer' }}
          onClick={toggleMenuVisibility}
        />
      </div>
      {visivel && (
        <div
          style={{
            position: 'absolute',
            backgroundColor: 'white',
            boxShadow: '0px 3px 6px #00000029',
            borderRadius: 5,
            marginTop: 90,
            marginRight: 30,
            zIndex: 5,
          }}
        >
          {menuStateOptions.map((item) => (
            <h1 key={item} className="FonteIcone" onClick={() => handleMenuItemClick(item)}>
              {item}
            </h1>
          ))}
        </div>
      )}
    </div>
  );
}
